module.exports = __webpack_public_path__ + "static/gallery-6@2x-20d077bd49742b4b97ea14b6b5cce7fe.jpg";